import { Grid, MenuItem, TextField } from "@mui/material";
import React from "react";
import InputGroupShape from "../../../../../../../components/Inputs/InputGroupShape";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../styles/muiProps";

export default function MaterialPanel() {
  const table = useMaterialReactTable({
    data: [
      { description: "Shell" },
      { description: "Head" },
      { description: "Nozzle Pipe" },
      { description: "Flange/Forging" },
      { description: "RF Pad" },
      { description: "Stud Blot / Nut" },
      { description: "Gasket" },
    ],
    columns: [
      {
        accessorKey: "description",
        header: "",
        // grow: false,
        size: 60,
        // Cell: ({ row }) => {
        //   // console.log({ row: row.original });
        //   return (
        //     <Box sx={{ textAlign: "center" }}>
        //       {row.original.heatNumber && (
        //         <DescriptionIcon sx={{ color: "#444" }} />
        //       )}
        //     </Box>
        //   );
        // },
      },
      {
        accessorKey: "material",
        header: "Material",
        // grow: false,
        size: 60,
        enableEditing: true,
        Cell: ({ cell }) => cell.getValue(),
        Edit: ({ cell, column, row, table }) => {
          const value = cell.getValue();
          return (
            <TextField
              select
              value={value}
              onChange={(e) => {
                table.options.meta?.updateData(
                  row.index,
                  column.id,
                  e.target.value
                );
              }}
              fullWidth
            >
              {["34"].map((role) => (
                <MenuItem key={role} value={role}>
                  {role}
                </MenuItem>
              ))}
            </TextField>
          );
        },
      },
      {
        accessorKey: "stress",
        header: "Stress (psi)",
        grow: false,
        size: 60,
        enableEditing: true,
        muiTableBodyCellEditTextFieldProps: {
          variant: "outlined",
        },
      },
      {
        accessorKey: "curve",
        header: "Curve",
        grow: false,
        size: 60,
      },
      {
        accessorKey: "requirement",
        header: "Requirement",
        grow: false,
        size: 60,
      },
    ],
    ...lightTable,
  });

  return (
    <Grid container>
      <Grid item xs={8} sx={{ pt: 2 }}>
        <InputGroupShape name="Material Data">
          <MaterialReactTable table={table} />
        </InputGroupShape>
      </Grid>
    </Grid>
  );
}
